import React, { Fragment, useEffect, useState } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { postMethod } from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";

const Stockin = (props) => {
  const [grid, setGrid] = React.useState([]);
  const [load, setLoad] = React.useState(false);
  const viewRecord = (val) => {
    var temp = window.btoa(val);
    props.history.push("/branch/stock-in/add?id=" + temp);
  };

  const [gridParam, setGridParam] = useState({});
  const columns = [
    {
      key: "datetime",
      text: "Date Time",
      align: "left",
      sortable: true,
    },
    {
      key: "stock_in_no",
      text: "Entry No",
      align: "left",
      sortable: true,
    },
      {
      key: "updated_qty",
      text: "Updated Qty",
      align: "left",
      sortable: true,
    },
    {
      key: "title",
      text: "Title",
      align: "left",
      sortable: true,
    },
    {
      key: "staff_name",
      text: "Staff Name",
      align: "left",
      sortable: true,
    },
    {
      key: "remark",
      text: "Remark",
      align: "left",
      sortable: true,
    },
//  {
//       key: "image",
//       text: "Image",
//       align: "left",
//       sortable: false,
//      cell: (record) => {
//   if (!record.image_path) return "No Image";

//   const imageSrc =
//     record.isImageUrl
//       ? record.image_path
//       : (record.url_image || "") + record.image_path;

//   return (
//     <img
//       src={imageSrc}
//       width="40"
//       height="40"
//       alt="product"
//       style={{ objectFit: "cover", borderRadius: 4 }}
//     />
//   );
// }
//     },    
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className="btn btn-link btn-sm"
              onClick={() => viewRecord(record.stock_in_no)}
              style={{ marginRight: "5px" }}
              title="View"
            >
              <i className="fa fa-eye"></i>
            </button>
          </Fragment>
        );
      },
    },
  ];

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
  };

  useEffect(() => {
    setLoad(true);
    postMethod("api/transactions/stockin/browse", gridParam).then((data) => {
      setGrid(data);
      setLoad(false);
    });
  }, []);

  return (
    <>
      {load ? <Loader /> : null}
      <div className="card card-custom gutter-b">
        <div className="card-header">
          <div className="card-title">
            <h3 className="card-label">Stock In</h3>
          </div>
          <div className="card-toolbar">
            <a
              href="/branch/stock-in/add"
              className="btn btn-sm btn-outline-theme font-weight-bold py-2 px-3"
            >
              <i className="flaticon2-user"></i> Stock In
            </a>
          </div>
        </div>
        <div className="card-body">
          <ReactDatatable config={config} records={grid} columns={columns} />
        </div>
      </div>
    </>
  );
};

export default Stockin;
